import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';
import SVGIcon from '../SVGIcon';
import logo from '../Header/promoter-ninja.svg';
import { setError, setOk } from '../../AppActions';
import { getError, getOk } from '../../AppReducer';
import Message from '../Message/Message';

const layoutFocusedRootSx = {
  display: 'flex',
  flexDirection: 'column',
};

const layoutFocusedContainerSx = {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 0 auto',
  minHeight: '100vh',
  px: 0,
};

const layoutFocusedMainSx = {
  flex: '1 0 auto',
  display: 'flex',
  flexDirection: 'column',
};

const layoutFocusedLogoSx = {
  width: 280,
  height: 47.531,
  margin: '3rem auto 1.5rem auto',
};

const layoutFocusedFooterSx = {
  margin: '2rem auto',
  '& p': {
    fontSize: 12,
    lineHeight: '2rem',
    mb: 0,
  },
};

const layoutFocusedMsgSx = {
  margin: '0 -1em 1em -1em',
  '& > div': {
    paddingLeft: '1em !important',
  },
};

function LayoutFocused(props) {
  const location = useLocation();
  useEffect(() => {
    props.setError();
    props.setOk();
  }, [location, props]);

  return (
    <Box sx={layoutFocusedRootSx}>
      <Box sx={{ ...layoutFocusedContainerSx, bgcolor: 'background.body' }}>
        <Box sx={layoutFocusedMainSx}>
          <Box sx={layoutFocusedLogoSx}>
            <Link to="/">
              <SVGIcon svg={logo} />
            </Link>
          </Box>
          <Helmet title={props.title} />
          {typeof window !== 'undefined' &&
            props.messagesPortal &&
            createPortal(
              <>
                {props.error ? (
                  <Box sx={layoutFocusedMsgSx}>
                    <Message
                      type="error"
                      msg={props.error}
                      onClose={props.setError}
                      maxWidth={props.maxWidth}
                    />
                  </Box>
                ) : null}
                {props.ok ? (
                  <Box sx={layoutFocusedMsgSx}>
                    <Message
                      type="ok"
                      msg={props.ok}
                      onClose={props.setOk}
                      maxWidth={props.maxWidth}
                    />
                  </Box>
                ) : null}
              </>,
              props.messagesPortal,
            )}

          <Box
            className={props.className}
            sx={{
              alignSelf: 'center',
              minWidth: '268px',
              maxWidth: props.maxWidth,
              margin: 'auto',
              ...props.sx,
            }}
          >
            {props.children}
          </Box>
        </Box>
        <Box sx={layoutFocusedFooterSx}>
          <p>
            &copy;
            {new Date().getFullYear()} &middot; Promoter Ninja
          </p>
          <p>
            <Link to="/privacy">
              <FormattedMessage id="Footer.Privacy" defaultMessage="Privacy Policy" />
            </Link>
          </p>
        </Box>
      </Box>
    </Box>
  );
}

LayoutFocused.defaultProps = {
  children: null,
  maxWidth: '435px',
  error: null,
  ok: null,
  className: undefined,
  sx: {},
  messagesPortal: null,
};

LayoutFocused.propTypes = {
  maxWidth: PropTypes.string,
  children: PropTypes.any,
  title: PropTypes.string.isRequired,
  error: PropTypes.string,
  ok: PropTypes.string,
  setError: PropTypes.func.isRequired,
  setOk: PropTypes.func.isRequired,
  className: PropTypes.string,
  sx: PropTypes.object,
  messagesPortal: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    error: getError(state),
    ok: getOk(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setError: msg => dispatch(setError(msg)),
    setOk: msg => dispatch(setOk(msg)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutFocused);
